import React from "react";
import { Link } from "react-router-dom";
import PageNotFound from "./public/PageNotFound.svg";

export default () => {
  return (
    <div className="p-5 text-center w-100 h-100 position-absolute bg-white" style={{ top: 0, left: 0, right: 0, bottom: 0, marginTop: 60 }}>
      <img id="404_img" src={PageNotFound} style={{ width: "100%", maxWidth: 480 }} alt="404" />
      <h4>
        <Link to="/">Go to Home</Link>
      </h4>
    </div>
  );
};
